import helperServices from '../../services/helperServices'

export default class {
  constructor (model) {
    this.closingDate = model.closingDate
    this.inputClosingDate = helperServices.getDateForInput(model.closingDate)
    this.gateClosingTime = model.gateClosingTime
    this.inputGateClosingTime = helperServices.getTimeForInput(model.gateClosingTime)
    this.highSeasonClosingTime = model.highSeasonClosingTime
    this.inputHighSeasonClosingTime = helperServices.getTimeForInput(model.highSeasonClosingTime)
    this.highSeasonOpeningTime = model.highSeasonOpeningTime
    this.inputHighSeasonOpeningTime = helperServices.getTimeForInput(model.highSeasonOpeningTime)
    this.lateArrivalAllowed = model.lateArrivalAllowed
    this.lateArrivalLimitTime = model.lateArrivalLimitTime
    this.inputLateArrivalLimitTime = helperServices.getTimeForInput(model.lateArrivalLimitTime)
    this.lateArrivalPhone = model.lateArrivalPhone
    this.lowSeasonClosingTime = model.lowSeasonClosingTime
    this.inputLowSeasonClosingTime = helperServices.getTimeForInput(model.lowSeasonClosingTime)
    this.lowSeasonOpeningTime = model.lowSeasonOpeningTime
    this.inputLowSeasonOpeningTime = helperServices.getTimeForInput(model.lowSeasonOpeningTime)
    this.nbPitches = model.nbPitches
    this.nbRentals = model.nbRentals
    this.openingDate = model.openingDate
    this.inputOpeningDate = helperServices.getDateForInput(model.openingDate)
    this.pitchArrivalEndTime = model.pitchArrivalEndTime
    this.inputPitchArrivalEndTime = helperServices.getTimeForInput(model.pitchArrivalEndTime)
    this.pitchArrivalStartTime = model.pitchArrivalStartTime
    this.inputPitchArrivalStartTime = helperServices.getTimeForInput(model.pitchArrivalStartTime)
    this.pitchDepartureEndTime = model.pitchDepartureEndTime
    this.inputPitchDepartureEndTime = helperServices.getTimeForInput(model.pitchDepartureEndTime)
    this.pitchDepartureStartTime = model.pitchDepartureStartTime
    this.inputPitchDepartureStartTime = helperServices.getTimeForInput(model.pitchDepartureStartTime)
    this.rentalArrivalEndTime = model.rentalArrivalEndTime
    this.inputRentalArrivalEndTime = helperServices.getTimeForInput(model.rentalArrivalEndTime)
    this.rentalArrivalStartTime = model.rentalArrivalStartTime
    this.inputRentalArrivalStartTime = helperServices.getTimeForInput(model.rentalArrivalStartTime)
    this.rentalDepartureEndTime = model.rentalDepartureEndTime
    this.inputRentalDepartureEndTime = helperServices.getTimeForInput(model.rentalDepartureEndTime)
    this.rentalDepartureStartTime = model.rentalDepartureStartTime
    this.inputRentalDepartureStartTime = helperServices.getTimeForInput(model.rentalDepartureStartTime)
    this.sqmSize = model.sqmSize
  }
}
